import Vue from 'vue'
import Element from 'element-ui'
import VueCookie from 'vuecookie'
import 'element-ui/lib/theme-chalk/index.css'
import {i18n} from './i18n'

Vue.config.productionTip = false;

Vue.use(Element, {
    i18n: (key, value) => {
        if (key === 'el.table.clearFilter') { // 那个全部显示成默认 hack by parker
            return i18n.locale === 'en' ? 'Default' : '默认'
        }
        return i18n.t(key, value)
    }
})

Vue.prototype.$toggleLocale = () => {
    let locale = i18n.locale
    locale === 'zh-CN' ? i18n.locale = 'en' : i18n.locale = 'zh-CN'
    VueCookie.set('lang', i18n.locale, {expires: '5Y'}) //后面会用做切换和将用户习惯存储到本地浏览器
}

Vue.prototype.$english = () => {
    return i18n.locale === 'en';
}
